export default __webpack_public_path__ + "static/media/chevron_down.2bd5db53.svg";